import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categories } from "@/mocks/guaData";
import { accentClassMap, getTopicsByCategory } from "@/utils/content";

export default function HomeCategories() {
  return (
    <section
      id="categories"
      className="w-full scroll-mt-28 bg-background-50"
      aria-labelledby="categories-title"
    >
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按圈子找你想看的瓜"
          description="六个主题覆盖日常讨论的主要场景。只想看某一类，直接进分类页，不用在信息流里翻找。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {categories.map((category) => {
            const count = getTopicsByCategory(category.slug).length;
            const accent = accentClassMap[category.accent];
            return (
              <article
                key={category.slug}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100/60 transition-colors hover:border-primary-200"
              >
                <Link
                  to={`/category/${category.slug}`}
                  className="relative block aspect-[4/3] w-full overflow-hidden bg-background-200"
                >
                  <img
                    src={category.image}
                    alt={`${category.name}分类 - 热门吃瓜话题聚合`}
                    title={`${category.name} - 热门吃瓜话题`}
                    className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <span className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
                  <span className="absolute bottom-4 left-4 flex items-center gap-2 text-background-50">
                    <span className={`flex h-8 w-8 items-center justify-center rounded-md ${accent.chip}`}>
                      <i className={`${category.icon} text-lg leading-none`} aria-hidden="true" />
                    </span>
                    <span className="heading-font text-lg font-bold">{category.name}</span>
                  </span>
                </Link>
                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <p className="text-sm leading-relaxed text-foreground-600">{category.description}</p>
                  <div className="mt-auto flex items-center justify-between pt-4">
                    <span className="text-xs text-foreground-500">当前在榜 {count} 个话题</span>
                    <Link
                      to={`/category/${category.slug}`}
                      className="flex cursor-pointer items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
                    >
                      进入分类
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true" />
                      </span>
                    </Link>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}